import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
import Avatar from '../../../general/Avatar';
export default /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  const {
    singleValueIconClassName,
    singleValueAvatarClassName,
    override
  } = props.selectProps.menuProps;
  const icon = props.data.icon;
  const iconType = props.data.iconType;
  const src = props.data.src;
  const placeholder = props.data.placeholder;
  let finalIcon;
  if (icon) finalIcon = icon;else if (iconType) finalIcon = /*#__PURE__*/React.createElement(Icon, {
    name: iconType
  });
  const iconKey = iconType || props.data.label;
  return components.SingleValue && /*#__PURE__*/React.createElement(components.SingleValue, props, finalIcon && /*#__PURE__*/React.createElement("div", _extends({
    key: iconKey,
    className: singleValueIconClassName
  }, override.actionIcon), finalIcon ? finalIcon : null), src && props.selectProps.showMediaInSelectedValues && /*#__PURE__*/React.createElement("div", {
    className: singleValueAvatarClassName
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: "small",
    src: src,
    placeholder: placeholder
  })), props.data.label);
});